import { render } from "./ActivityButton.vue?vue&type=template&id=972e976e&scoped=true"
import script from "./ActivityButton.vue?vue&type=script&lang=js"
export * from "./ActivityButton.vue?vue&type=script&lang=js"

import "./ActivityButton.vue?vue&type=style&index=0&id=972e976e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972e976e"]])

export default __exports__